import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormControlBase } from './form-control-base';

@Injectable()
export class FormGroupService {

    public toFormGroup(fields: FormControlBase<any>[]): FormGroup {
        let group: any = {};
        fields.forEach(field => {

            let validators = new Array<any>();
            if (field.required) {
                validators.push(Validators.required);
            }
            if (field.validNoNumber) {
                validators.push(Validators.pattern('^[a-zA-Z\-\']+'));
            }
            if (field.validEmail) {
                validators.push(Validators.pattern('^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$'));
            }
            if (field.validNumberOnly) {
                validators.push(Validators.pattern('^[0-9]+$'));
            }
            group[field.key] = validators.length ? new FormControl(field.value || '', Validators.compose(validators)) : new FormControl(field.value || '');
            if (field.disabled) {
                group[field.key].disable();
            }
        });
        return new FormGroup(group);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/dynamic-form.service.ts